import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Add Bearer token from localStorage if available (fallback for browsers blocking cookies)
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("alfie_access_token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auto-refresh on 401
API.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && !original.url?.includes("/auth/")) {
      original._retry = true;
      try {
        const refreshToken = localStorage.getItem("alfie_refresh_token");
        const headers = refreshToken ? { Authorization: `Bearer ${refreshToken}` } : {};
        const { data } = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/auth/refresh`,
          {},
          { withCredentials: true, headers }
        );
        if (data.access_token) {
          localStorage.setItem("alfie_access_token", data.access_token);
        }
        return API(original);
      } catch {
        localStorage.removeItem("alfie_access_token");
        localStorage.removeItem("alfie_refresh_token");
        window.location.href = "/login";
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

// Helper: save tokens from login/register response
export function saveTokens(data) {
  if (data.access_token) localStorage.setItem("alfie_access_token", data.access_token);
  if (data.refresh_token) localStorage.setItem("alfie_refresh_token", data.refresh_token);
}

export function clearTokens() {
  localStorage.removeItem("alfie_access_token");
  localStorage.removeItem("alfie_refresh_token");
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default API;
